import {
  RUN_SIMULATION_SUCCESS,
  RUN_SIMULATION_FAILURE,
  RUN_SIMULATION_REQUEST,
  INVALIDATE_SIMULATION,
} from '../actions/simulations';

const initialState = {
  byKey: {},
  isRunning: false,
  error: null,
};

export default(state = initialState, action) => {
  const { type, payload = {} } = action;
  const { error, key, simulation } = payload;

  switch(type) {
    case RUN_SIMULATION_REQUEST:
      return {
        ...state,
        isRunning: true,
        error: null,
      };
    case RUN_SIMULATION_FAILURE:
      return {
        ...state,
        isRunning: false,
        error,
        byKey: Object.keys(state.byKey).reduce((acc, key) => {
          if (key !== payload.key) {
            acc[key] = state.byKey[key];
          }
          return acc;
        }, {}),
      };
    case RUN_SIMULATION_SUCCESS:
      return {
        ...state,
        isRunning: false,
        byKey: {
          ...state.byKey,
          [key]: {
            ...simulation,
          },
        },
      };
    case INVALIDATE_SIMULATION:
      return {
        ...state,
        byKey: Object.keys(state.byKey).reduce((acc, key) => {
          if (key !== payload.key) {
            acc[key] = state.byKey[key];
          }
          return acc;
        }, {}),
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/simulations.js